import { Action } from 'redux/actions'
import { RootState } from 'types'

export default function reduce(state: RootState['favorites'] = [], action: Action): RootState['favorites'] {
  switch (action.type) {
    case 'FAVORITES_SET': {
      return action.payload
    }
    case 'ADD_FAVORITE': {
      return [...state, action.payload]
    }
    case 'DELETE_FAVORITE': {
      return state.filter(({ id }) => id !== action.payload)
    }
    default:
      return state
  }
}
